module.exports = __webpack_public_path__ + "media/recipes/87-ad537574.png";